/**
 * Indicadores ANS — a nota do IDSS da operadora comparada ao mercado, a Frente
 * IDSS (as regras das fichas técnicas aplicadas na nossa base, com a lista de
 * quem falta) e os rastreamentos acompanhados além do IDSS.
 *
 * Saiu de Contabilidade: quem usa é qualidade, atenção à saúde e a diretoria
 * assistencial. Os componentes continuam em pages/contabilidade (Idss.js,
 * IdssBase.js); as rotas são as do módulo indicadores_ans.
 */
import React, { useEffect, useState } from "react";
import { Award } from "lucide-react";
import api from "../services/api";
import { useAuth } from "../context/AuthContext";
import { T, InfoTip, Card } from "./contabilidade/ui";
import { FiltroOperadoras } from "./contabilidade/DemonstracoesContabeis";
import IdssComparacao from "./contabilidade/Idss";
import IdssBase from "./contabilidade/IdssBase";
import PainelIndicadores from "./contabilidade/PainelIndicadores";

export default function IndicadoresAns() {
  const { user, temNivel } = useAuth();
  const gestor = temNivel("indicadores_ans", "gestor");
  const chaveSel = `ind_ans_comparar_${user?.id ?? user?.email ?? "anon"}`;
  const [sel, setSelInterno] = useState(() => {
    try {
      const s = JSON.parse(localStorage.getItem(chaveSel) || "[]");
      return Array.isArray(s) ? s.filter((o) => o && o.registro_ans).slice(0, 3) : [];
    } catch { return []; }
  });
  const setSel = (lista) => {
    setSelInterno(lista);
    try { localStorage.setItem(chaveSel, JSON.stringify(lista)); } catch { /* sem storage: só não lembra */ }
  };
  const [proprio, setProprio] = useState({ registro: "", nome: "", max: 3 });

  useEffect(() => {
    api.get("/indicadores-ans/idss").then((r) => {
      const reg = r.data.registro_proprio || "";
      const nome = (r.data.operadoras || []).find((o) => o.registro_ans === reg)?.nome || "";
      setProprio({ registro: reg, nome, max: r.data.max_comparadas || 3 });
    }).catch(() => {});
  }, []);

  const regsSel = sel.map((o) => o.registro_ans).join(",");

  return (
    <div style={{ padding: 20, background: T.bg, minHeight: "100%" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
        <Award size={22} color={T.teal} />
        <h2 style={{ margin: 0, color: T.ink }}>Indicadores ANS</h2>
        <InfoTip w={380} texto="A nota de qualidade que a ANS dá às operadoras (IDSS), a comparação com o mercado e a Frente IDSS: as regras públicas de cada indicador aplicadas na nossa carteira, com a lista de quem falta para montar campanhas. Os rastreamentos 'além do IDSS' seguem o Ministério da Saúde/INCA." />
      </div>
      <p style={{ margin: "0 0 14px", fontSize: 13, color: T.inkSoft }}>
        IDSS da operadora e do mercado (dados abertos da ANS) e os indicadores calculados na nossa base.
      </p>
      <PainelIndicadores />
      <Card style={{ marginBottom: 12, padding: 14 }}>
        <FiltroOperadoras proprio={proprio.registro} nomeProprio={proprio.nome} sel={sel} setSel={setSel}
          max={proprio.max} urlBusca="/indicadores-ans/operadoras" />
      </Card>
      <IdssComparacao comparar={regsSel} />
      <IdssBase gestor={gestor} />
    </div>
  );
}
